import Slide from '@/mixins/Slide'

export default
{
    mixins: [
        Slide
    ]
}
